import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CourseState {
  course: any;
  isCourseDetail: boolean;
  similarCourseList: any[];
  courseShortlistData: any[];

}

const initialState: CourseState = {
  course: null,
  isCourseDetail: false,
  similarCourseList: [],
  courseShortlistData: []
}

const courseSlice = createSlice({
  name: "CourseContents",
  initialState,
  reducers: {
    setCourse(state, action: PayloadAction<any>) {
      state.course = action.payload;
    },
    setIsCourseDetail(state, action: PayloadAction<any>) {
      state.isCourseDetail = action.payload;
    },
    setSimilarCourse(state, action: PayloadAction<any>) {
      state.similarCourseList = action.payload;
    },
    updateCourseData(state, action: PayloadAction<{ key: string; value: any }>) {
      if (state.course.college) {
        state.course.college[action.payload.key] = action.payload.value;
      }
    },
    setCourseShortlist(state, action: PayloadAction<any>) {
      state.courseShortlistData = action.payload;
    },
    clearCourseState: () => initialState,
  }
})

export const {
  setCourse,
  setIsCourseDetail,
  setSimilarCourse,
  updateCourseData,
  setCourseShortlist,
  clearCourseState,
} = courseSlice.actions
export default courseSlice.reducer;